import { Pipe, PipeTransform } from "@angular/core";
import { InvitationStatusEnum } from "@models/invitation";

@Pipe({
  name: "invitationStatusEnum",
  standalone: true,
})
export class InvitationStatusEnumPipe implements PipeTransform {
  transform(value: InvitationStatusEnum): unknown {
    switch (value) {
      case InvitationStatusEnum.ACCEPTED:
        return "Aceito";
      case InvitationStatusEnum.DECLINED:
        return "Recusado";
      case InvitationStatusEnum.PENDING:
        return "Pendente";
      case InvitationStatusEnum.CANCELLED:
        return "Cancelado";
      case InvitationStatusEnum.EXPIRED:
        return "Expirado";
      case InvitationStatusEnum.REVOKED:
        return "Revogado";
      case InvitationStatusEnum.CANCELED:
        return "Cancelado";
      default:
        return value;
    }
  }
}
